/** Services */
export { DsCampaignsService } from './services/ds-campaigns.service';
export { DsCampaignUserGroupsService } from './services/ds-campaign-user-groups.service';

/** Models */
export { DsCampaign } from './models/ds-campaign.class';
export { DsCampaignUserGroup } from './models/ds-campaign-user-group.class';

/** Interfaces */
export { DsCampaignsFilterInterface } from './interfaces/ds-campaigns-filter.interface';
